<template>
  <div>
    <checkbox v-for="(item, index) in box" :true-value="item.id" v-model="itemArray[index]" @on-change="selectArray">
      <span>{{item.title}}</span>
    </checkbox>
  </div>
</template>
<script>
  import Checkbox from 'iview/src/components/checkbox/checkbox'

  export default {
    components: {Checkbox},
    name: 'CheckBox',
    props: {
      boxList: {
        type: Array,
        default () {
          return ''
        },
      },
    },
    data () {
      return {
        box: [],
        itemArray: [],
        returnArray: [],
      }
    },
    methods: {
      selectArray () {
        let self = this
        self.returnArray = []
        for (var index = 0; index < self.itemArray.length; index++) {
          if (self.itemArray[index]) {
            self.returnArray.push(self.itemArray[index])
          }
        }
        self.$emit('on-select-change', self.returnArray)
      },
    },
    watch: {
      boxList (val) {
        this.box = val
      },
    }
  }
</script>



// WEBPACK FOOTER //
// CheckBox.vue?858e8940